import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  ATTENDANCE_OFFICE_LIST,
  LOCATION_TYPE,
  ATTENDANCE_SITE_LIST,
} from './type';

export const getAttendanceLocationType = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    Config.attendance.attendanceList
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({
      type: LOCATION_TYPE,
      payload: data?.response?.data,
    });
  } else {
    return res;
  }
};

export const getAttendanceOfficeList = (id, lat, lng) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.attendance.attendanceOfficeList}?location_type=${id}&latitude=${lat}&longitude=${lng}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({
      type: ATTENDANCE_OFFICE_LIST,
      payload: data?.response?.data,
    });
  } else {
    return res;
  }
};

export const getAttendanceSiteList = (id, lat, lng) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.attendance.attendanceSiteList}?location_type=${id}&latitude=${lat}&longitude=${lng}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({
      type: ATTENDANCE_SITE_LIST,
      payload: data?.response?.data,
    });
  } else {
    return res;
  }
};

export const employeeAttendanceData = ({
  id,
  lat,
  lng,
  type,
  purpose,
  locationType,
  remark
}) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.attendance.storeEmployeeAttendanceData}?latitude=${lat}&longitude=${lng}&location_id=${id}&type=${type}&location_type=${locationType}&purpose=${purpose}&remark=${remark}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const employeeCheckOutData = ({
  lat,
  lng,
  type,
  att_id,
}) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    '',
    `${Config.attendance.storeEmployeeAttendanceData}?latitude=${lat}&longitude=${lng}&type=${type}&att_id=${att_id}`
  );
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};
